// extracted by mini-css-extract-plugin
export default {"MergeQueueSectionText":"MergeQueueSection-module__MergeQueueSectionText__3ok5u9h"};